import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServiceHeader from "../components/ServiceHeader";
import Connect from "../components/Connect";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import axios from "axios";
import API_URL from "../config";
import "../static/css/MemberPage.css";

function MemberPage() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Fetching member with ID:", id);
    axios
      .get(`${API_URL}/team/members/${id}`)
      .then((response) => {
        const fetchedMember = response.data;
        if (typeof fetchedMember.specializations === "string") {
          fetchedMember.specializations = JSON.parse(
            fetchedMember.specializations
          );
        }
        setMember(fetchedMember);
        console.log("Fetched member data:", fetchedMember);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching member details:", error.response ? error.response.data : error.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!member) {
    return <div>Member not found</div>;
  }

  return (
    <>
      <Nav />
      <div className="member-content">
        <div className="member-header-row">
          <div className="member-header-text">
            <ServiceHeader title={member.name} description={member.role} />
          </div>

          {member.image && (
            <div className="member-image-container">
              <img 
                src={`${API_URL}${member.image.replace(/\\/g, "/")}`} 
                alt={member.name}
                className="member-detail-image"
                onError={(e) => {
                  console.error("Image failed to load:", e.target.src);
                  e.target.style.display = "none";
                }}
              />
            </div>
          )}
        </div>

        <p className="member-bio">{member.description || "No description available."}</p>
        
        {member.credentials && (
          <>
            <h3 className="member-specializations-header">Key Professional Credentials:</h3>
            <p className="member-credentials">{member.credentials}</p>
          </>
        )}

        {Array.isArray(member.specializations) && member.specializations.filter(s => s && s.trim()).length > 0 && (
          <>
            <h3 className="member-specializations-header">Specializations:</h3>
            <ul className="member-specializations-list">
              {member.specializations.filter(s => s && s.trim()).map((spec, index) => (
                <li key={index} className="member-specialization-item">
                  {spec}
                </li>
              ))}
            </ul>
          </>
        )}

        <div className="member-contact-section">
          <h3 className="member-specializations-header">Get in Touch:</h3>
          <div className="member-contact-info">
            {member.email ? (
              <p className="member-contact-item">
                <strong>📧 Email:</strong> <a href={`mailto:${member.email}`}>{member.email}</a>
              </p>
            ) : (
              <p className="member-contact-item" style={{ color: "#999" }}>📧 Email: Not provided</p>
            )}
            {member.phone ? (
              <p className="member-contact-item">
                <strong>📱 Phone:</strong> <a href={`tel:${member.phone}`}>{member.phone}</a>
              </p>
            ) : (
              <p className="member-contact-item" style={{ color: "#999" }}>📱 Phone: Not provided</p>
            )}
            {member.linkedin_url ? (
              <p className="member-contact-item">
                <strong>🔗 LinkedIn:</strong> <a href={member.linkedin_url} target="_blank" rel="noopener noreferrer">View Profile</a>
              </p>
            ) : (
              <p className="member-contact-item" style={{ color: "#999" }}>🔗 LinkedIn: Not provided</p>
            )}
          </div>
        </div>
      </div>
      <Connect />
      <Footer />
    </>
  );
}

export default MemberPage;
